import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

/** Normalize the many shapes FastAPI can return in error.detail. */
export function formatApiErrorDetail(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof d === "object" && d.message) return d.message;
  return String(d);
}

export function errorCode(err) {
  return err?.response?.data?.detail?.error_code || null;
}

/** Resolve a relative /api/media URL against REACT_APP_BACKEND_URL. */
export function assetUrl(u) {
  if (!u) return "";
  if (u.startsWith("http://") || u.startsWith("https://")) return u;
  return `${BACKEND_URL}${u}`;
}
